(function () {
  // CONFIG
  const ZOOM_LEVEL = 2.2;      // initial zoom when activated
  const HIGH_RES_ATTR = 'data-full-src';
  const TAP_MAX_DURATION = 250; // ms for quick tap detection
  const TAP_MAX_MOVEMENT = 8;   // px max movement to consider a tap
  const MIN_SCALE = 1.0;
  const MAX_SCALE = 5.0;

  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }

  function createKonvaForAnchor(anchor, fullImageSrc, initialZoom) {
    const konvaContainer = document.createElement('div');
    konvaContainer.className = 'pmg-konva-container';
    // ensure CSS has: .pmg-konva-container { touch-action: none; }
    const rect = anchor.getBoundingClientRect();
    konvaContainer.style.width = rect.width + 'px';
    konvaContainer.style.height = rect.height + 'px';
    konvaContainer.style.position = 'absolute';
    konvaContainer.style.top = '0';
    konvaContainer.style.left = '0';
    konvaContainer.style.overflow = 'hidden';
    konvaContainer.style.zIndex = 50;

    if (getComputedStyle(anchor).position === 'static') anchor.style.position = 'relative';
    anchor.appendChild(konvaContainer);

    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = () => {
        // Create stage
        const stage = new Konva.Stage({
          container: konvaContainer,
          width: rect.width,
          height: rect.height,
        });
        const layer = new Konva.Layer();
        stage.add(layer);

        const iw = img.naturalWidth;
        const ih = img.naturalHeight;
        const stageW = stage.width();
        const stageH = stage.height();
        const fitScale = Math.max(stageW / iw, stageH / ih);

        const kImage = new Konva.Image({
          image: img,
          x: 0,
          y: 0,
          width: iw * fitScale,
          height: ih * fitScale,
          listening: false
        });
        layer.add(kImage);

        // center
        kImage.x((stageW - kImage.width()) / 2);
        kImage.y((stageH - kImage.height()) / 2);

        // state
        let currentScale = initialZoom || ZOOM_LEVEL;
        layer.scale({ x: currentScale, y: currentScale });
        layer.draw();

        // touch/pinch state
        let isTouchPanning = false;
        let lastTouchPos = null;
        let lastTouchDistance = null;

        // tap detection
        let touchStartTime = 0;
        let touchStartPos = null;
        let movedSinceTouchStart = false;

        const containerEl = stage.container();

        function scaledSize() {
          return { w: kImage.width() * layer.scaleX(), h: kImage.height() * layer.scaleY() };
        }
        function clampLayerPosition() {
          const { w: scaledW, h: scaledH } = scaledSize();
          const minX = Math.min(0, stageW - scaledW);
          const maxX = 0;
          const minY = Math.min(0, stageH - scaledH);
          const maxY = 0;
          layer.x(clamp(layer.x(), minX, maxX));
          layer.y(clamp(layer.y(), minY, maxY));
        }

        // pointer (mouse) pan: keep pointer point stable
        function onPointerMove() {
          const pos = stage.getPointerPosition();
          if (!pos) return;
          const { w: scaledW, h: scaledH } = scaledSize();
          const relX = pos.x / stageW;
          const relY = pos.y / stageH;
          const targetX = clamp(- (relX * scaledW - pos.x), Math.min(0, stageW - scaledW), 0);
          const targetY = clamp(- (relY * scaledH - pos.y), Math.min(0, stageH - scaledH), 0);
          layer.x(targetX);
          layer.y(targetY);
          layer.batchDraw();
        }

        // wheel zoom at cursor
        function onWheel(e) {
          e.preventDefault();
          const delta = e.deltaY;
          const factor = delta > 0 ? 0.92 : 1.08;
          const oldScale = layer.scaleX();
          let newScale = clamp(oldScale * factor, MIN_SCALE, MAX_SCALE);

          const rectBounds = containerEl.getBoundingClientRect();
          const cx = e.clientX - rectBounds.left;
          const cy = e.clientY - rectBounds.top;
          const oldImgX = (cx - layer.x()) / oldScale;
          const oldImgY = (cy - layer.y()) / oldScale;

          layer.scale({ x: newScale, y: newScale });
          layer.x(cx - oldImgX * newScale);
          layer.y(cy - oldImgY * newScale);

          clampLayerPosition();
          layer.batchDraw();
          currentScale = newScale;
        }

        // TOUCH HELPERS
        function getTouchPos(touch) {
          const rectBounds = containerEl.getBoundingClientRect();
          return { x: touch.clientX - rectBounds.left, y: touch.clientY - rectBounds.top };
        }
        function getTouchDistance(touches) {
          if (!touches || touches.length < 2) return 0;
          const a = touches[0], b = touches[1];
          const dx = a.clientX - b.clientX;
          const dy = a.clientY - b.clientY;
          return Math.sqrt(dx * dx + dy * dy);
        }

        function onTouchStart(e) {
          if (!e || !e.touches) return;
          touchStartTime = Date.now();
          movedSinceTouchStart = false;
          if (e.touches.length === 1) {
            isTouchPanning = true;
            lastTouchPos = getTouchPos(e.touches[0]);
            touchStartPos = lastTouchPos;
          } else if (e.touches.length === 2) {
            isTouchPanning = false;
            lastTouchDistance = getTouchDistance(e.touches);
            // store midpoint for zoom focus
            touchStartPos = {
              x: (e.touches[0].clientX + e.touches[1].clientX) / 2 - containerEl.getBoundingClientRect().left,
              y: (e.touches[0].clientY + e.touches[1].clientY) / 2 - containerEl.getBoundingClientRect().top
            };
          }
          e.preventDefault();
        }

        function onTouchMove(e) {
          if (!e || !e.touches) return;
          if (e.touches.length === 1 && isTouchPanning) {
            const pos = getTouchPos(e.touches[0]);
            if (!lastTouchPos) lastTouchPos = pos;
            const dx = pos.x - lastTouchPos.x;
            const dy = pos.y - lastTouchPos.y;
            if (Math.abs(dx) > 1 || Math.abs(dy) > 1) movedSinceTouchStart = true;
            layer.x(layer.x() + dx);
            layer.y(layer.y() + dy);
            clampLayerPosition();
            layer.batchDraw();
            lastTouchPos = pos;
            e.preventDefault();
          } else if (e.touches.length === 2) {
            const dist = getTouchDistance(e.touches);
            if (!lastTouchDistance) {
              lastTouchDistance = dist;
              return;
            }
            const scaleFactor = dist / lastTouchDistance;
            let newScale = clamp(currentScale * scaleFactor, MIN_SCALE, MAX_SCALE);

            // midpoint for focal zoom
            const rectBounds = containerEl.getBoundingClientRect();
            const midClientX = (e.touches[0].clientX + e.touches[1].clientX) / 2;
            const midClientY = (e.touches[0].clientY + e.touches[1].clientY) / 2;
            const midStageX = midClientX - rectBounds.left;
            const midStageY = midClientY - rectBounds.top;

            const oldScale = layer.scaleX();
            const oldImgX = (midStageX - layer.x()) / oldScale;
            const oldImgY = (midStageY - layer.y()) / oldScale;

            layer.scale({ x: newScale, y: newScale });

            // reposition layer so same image point remains under midpoint
            const newLayerX = midStageX - oldImgX * newScale;
            const newLayerY = midStageY - oldImgY * newScale;
            layer.x(newLayerX);
            layer.y(newLayerY);

            currentScale = newScale;
            lastTouchDistance = dist;
            clampLayerPosition();
            layer.batchDraw();
            e.preventDefault();
          }
        }

        function onTouchEnd(e) {
          // quick-tap detection: short duration + small movement -> treat as tap (close)
          const duration = Date.now() - touchStartTime;
          const moved = movedSinceTouchStart;
          if (duration <= TAP_MAX_DURATION && !moved) {
            // treat as quick tap -> signal to caller to close
            // We'll dispatch a custom event 'konva-tap' on containerEl
            const ev = new CustomEvent('konva-tap', { bubbles: true });
            containerEl.dispatchEvent(ev);
          }
          // reset states
          if (!e || !e.touches || e.touches.length === 0) {
            isTouchPanning = false;
            lastTouchPos = null;
            lastTouchDistance = null;
          } else if (e.touches.length === 1) {
            isTouchPanning = true;
            lastTouchPos = getTouchPos(e.touches[0]);
            lastTouchDistance = null;
          }
        }

        // start / stop / destroy
        function start() {
          stage.on('mousemove', onPointerMove);
          containerEl.addEventListener('wheel', onWheel, { passive: false });
          containerEl.addEventListener('touchstart', onTouchStart, { passive: false });
          containerEl.addEventListener('touchmove', onTouchMove, { passive: false });
          containerEl.addEventListener('touchend', onTouchEnd, { passive: false });
        }
        function stop() {
          try {
            stage.off('mousemove', onPointerMove);
            containerEl.removeEventListener('wheel', onWheel);
            containerEl.removeEventListener('touchstart', onTouchStart);
            containerEl.removeEventListener('touchmove', onTouchMove);
            containerEl.removeEventListener('touchend', onTouchEnd);
          } catch (e) {}
        }
        function destroy() {
          try { stop(); } catch (e) {}
          try { stage.destroy(); } catch (e) {}
          if (konvaContainer && konvaContainer.parentNode) konvaContainer.parentNode.removeChild(konvaContainer);
        }

        resolve({
          stage, layer, kImage,
          start, stop, destroy,
          setScale: function (s) {
            currentScale = clamp(s, MIN_SCALE, MAX_SCALE);
            layer.scale({ x: currentScale, y: currentScale });
            clampLayerPosition();
            layer.batchDraw();
          },
          containerEl
        });
      };
      img.onerror = (err) => reject(err);
      img.src = fullImageSrc;
    });
  }

  // Main activation / wiring
  function initClickToActivateKonva() {
    const anchors = document.querySelectorAll('a.pmg-thumb-link');
    if (!anchors || anchors.length === 0) return;

    // close on outside click
    document.addEventListener('click', function (evt) {
      const activeAnchors = document.querySelectorAll('a.pmg-thumb-link.konva-active');
      activeAnchors.forEach(a => {
        if (!a.contains(evt.target)) {
          const inst = a.__konvaInstance;
          if (inst && typeof inst.destroy === 'function') {
            inst.destroy();
            a.__konvaInstance = null;
          }
          a.classList.remove('konva-active');
        }
      });
    }, true);

    // escape to close
    window.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        const activeAnchors = document.querySelectorAll('a.pmg-thumb-link.konva-active');
        activeAnchors.forEach(a => {
          const inst = a.__konvaInstance;
          if (inst && typeof inst.destroy === 'function') {
            inst.destroy();
            a.__konvaInstance = null;
          }
          a.classList.remove('konva-active');
        });
      }
    });

    anchors.forEach(anchor => {
      const img = anchor.querySelector('img.pmg-thumb-img');
      if (!img) return;
      const fullSrc = img.getAttribute(HIGH_RES_ATTR) || img.src;
      if (!fullSrc) return;
      const root = anchor.closest('[data-zoom-enabled]');
      if (root && root.getAttribute('data-zoom-enabled') === 'false') return;

      anchor.addEventListener('click', async function (e) {
        // toggle off if active
        if (anchor.classList.contains('konva-active')) {
          e.preventDefault();
          const inst = anchor.__konvaInstance;
          if (inst && typeof inst.destroy === 'function') {
            inst.destroy();
            anchor.__konvaInstance = null;
          }
          anchor.classList.remove('konva-active');
          return;
        }

        // activate zoom instead of opening popup/navigation
        e.preventDefault();
        anchor.classList.add('konva-active');

        try {
          // ensure Konva lib loaded
          if (typeof Konva === 'undefined') {
            // load dynamically (simple loader)
            await new Promise((res, rej) => {
              const s = document.createElement('script');
              s.src = 'https://unpkg.com/konva@9/konva.min.js';
              s.onload = res;
              s.onerror = rej;
              document.head.appendChild(s);
            });
          }

          const inst = await createKonvaForAnchor(anchor, fullSrc, ZOOM_LEVEL);
          anchor.__konvaInstance = inst;
          inst.start();

          // If user quick-taps on the konva container, close (touch quick-tap)
          inst.containerEl.addEventListener('konva-tap', function () {
            try {
              if (inst && typeof inst.destroy === 'function') {
                inst.destroy();
                anchor.__konvaInstance = null;
              }
              anchor.classList.remove('konva-active');
            } catch (e) {}
          }, { once: true });

        } catch (err) {
          console.warn('Konva activation failed', err);
          anchor.classList.remove('konva-active');
          anchor.__konvaInstance = null;
        }
      });

      // cleanup on contextmenu
      anchor.addEventListener('contextmenu', function () {
        const inst = anchor.__konvaInstance;
        if (inst && typeof inst.destroy === 'function') {
          inst.destroy();
          anchor.__konvaInstance = null;
        }
        anchor.classList.remove('konva-active');
      });
    });
  }

  // init
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initClickToActivateKonva);
  } else {
    initClickToActivateKonva();
  }

  // resize debounce re-init
  let resizeTimer = null;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      initClickToActivateKonva();
    }, 250);
  });
})();